import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tw-text-left" }
const _hoisted_2 = { class: "tw-px-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "openNoteModal3",
    class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold ms-auto",
    style: {"border":"none"},
    "data-bs-toggle": "modal",
    "data-bs-target": "#note-Modal-create-mlo-tc"
  }, " SEE NOTE ")
], -1)
const _hoisted_4 = { class: "tw-flex tw-items-center tw-ml-[15px] tw-pt-[15px] tw-justify-between" }
const _hoisted_5 = { class: "tw-flex tw-gap-[40px]" }
const _hoisted_6 = { class: "tw-flex tw-justify-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "tw-pl-3 tw-text-white tw-text-[15px]" }, "REALTOR FORM", -1)
const _hoisted_9 = { class: "tw-flex tw-gap-[40px] tw-px-3" }
const _hoisted_10 = {
  href: "#",
  class: "tw-flex tw-items-center tw-justify-center tw-bg-[#00A0DA] tw-rounded-[15px] tw-pr-3 tw-pl-3 tw-pt-5 tw-pb-5"
}
const _hoisted_11 = {
  class: "btn btn-secondary dropdown-toggle tw-bg-[#00A0DA] tw-flex tw-items-center tw-text-[15px] tw-pt-0 tw-pb-0 tw-border-transparent tw-hover:bg-transparent tw-outline-none",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "dropdown-menu tw-absolute tw-top-[22px] bg-transparent border-0",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_14 = {
  type: "button",
  class: "btn tw-flex tw-items-center tw-bg-[#00A0DA] tw-w-[205px] tw-rounded-[15px] tw-pr-3 tw-pl-3 tw-pb-5 tw-pt-5",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalTablesMLO"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "tw-pl-3 tw-text-white tw-text-[15px]" }, "MLO", -1)
const _hoisted_17 = { class: "mt-2" }
const _hoisted_18 = {
  type: "button",
  class: "tw-flex tw-items-center tw-bg-[#00A0DA] tw-w-[205px] tw-rounded-[15px] tw-pr-3 tw-pl-3 tw-pb-5 tw-pt-5",
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModalTittle"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "tw-pl-3 tw-text-white tw-text-[15px]" }, "TITLE COMPANY", -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\" id=\"note-Modal-create-mlo-tc\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\">Some applications require information from a Mortgage Loan Originator when there is a financing calculation.<br><br> It may be that there is no MLO on file in this section. <br><br> In that case, the financial information must be filled out in <strong>CREATE (MLO &amp; TITLE COMPANY)</strong>. <br><br> This information should be requested from the MLO agent with whom the Realtor works regularly. (For convenience, invite the MLOs you know to enter the required information). <br><br> If there is no Title Company on file, the Realtor must fill out the required information by selecting the TITLE COMPANY box. This information can be requested from the Title Company with whom the Realtor works regularly. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 1)
const _hoisted_22 = {
  class: "modal fade modal-xl",
  id: "exampleModalTypeInspector",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_28 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE-NUMBER")
  ])
], -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  class: "modal fade",
  id: "exampleModalTittle",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog modal-xl" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_38 = { class: "modal-body" }
const _hoisted_39 = {
  class: "modal fade modal-xl",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_40 = { class: "modal-dialog" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_43 = { class: "modal-body" }
const _hoisted_44 = {
  key: 0,
  class: "comment-box-form"
}
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<p class=\"text-center\">The variables presented in this format are applicable to various calculation scenarios. These variables can be adjusted in two ways:</p><br><h3 class=\"text-center\"><b>1. General estimation: </b></h3><p class=\"text-center\">If you want to make an estimate for an undetermined property, an average of the variable&#39;s behavior in the county you want to use for the calculation in the application is used. </p><br><h3 class=\"text-center\"><b>2. Specific property:</b></h3><p class=\"text-center\">If you have an identified property and know the payments made on it, such as the amount paid in property taxes, you should adjust the variables proportionally for a more accurate estimation. </p>", 7)
const _hoisted_52 = [
  _hoisted_45
]
const _hoisted_53 = {
  class: "modal fade modal-xl",
  id: "exampleModal2",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog" }
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_59 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  class: "modal fade modal-xl",
  id: "exampleModaltitle",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_69 = { class: "modal-dialog" }
const _hoisted_70 = { class: "modal-content" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_72 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_73 = { class: "d-flex justify-content-center" }
const _hoisted_74 = { class: "mlo-tables d-flex flex-column px-4" }
const _hoisted_75 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_76 = { class: "pb-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Closing Close")
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_79 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_80 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = { class: "mlo-tables d-flex flex-column px-4" }
const _hoisted_84 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_85 = { class: "pb-3" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Other Price")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_88 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_89 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = ["onUpdate:modelValue"]
const _hoisted_92 = {
  class: "modal fade modal-xl",
  id: "exampleModal3",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_93 = { class: "modal-dialog" }
const _hoisted_94 = { class: "modal-content" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_96 = { class: "modal-body" }
const _hoisted_97 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_98 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_100 = { key: 0 }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-pb-4" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl" }, " SAVE ")
], -1)
const _hoisted_108 = {
  class: "modal fade modal-xl",
  id: "exampleModalinspector",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_109 = { class: "modal-dialog" }
const _hoisted_110 = { class: "modal-content" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_112 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_113 = { class: "tw-flex tw-justify-center" }
const _hoisted_114 = { class: "mlo-tables d-flex flex-column px-4" }
const _hoisted_115 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_116 = { class: "pb-3" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "INSPECTOR")
], -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_119 = { class: "tw-flex tw-justify-center tw-w-full" }
const _hoisted_120 = { class: "table-mlo w-50 bg-white p-3 rounded-4" }
const _hoisted_121 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SQFT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PRICE $")
  ])
], -1)
const _hoisted_123 = ["onUpdate:modelValue"]
const _hoisted_124 = ["onUpdate:modelValue"]
const _hoisted_125 = {
  class: "modal fade modal-xl",
  id: "exampleModal4",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_126 = { class: "modal-dialog" }
const _hoisted_127 = { class: "modal-content" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_129 = { class: "modal-body" }
const _hoisted_130 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_131 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_133 = { key: 0 }
const _hoisted_134 = ["onClick"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = { key: 1 }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_139 = [
  _hoisted_138
]
const _hoisted_140 = {
  class: "modal fade",
  id: "modalTablesMLO",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_141 = { class: "modal-dialog modal-xl" }
const _hoisted_142 = { class: "modal-content" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_144 = { class: "modal-body" }
const _hoisted_145 = {
  class: "modal fade modal-xl",
  id: "exampleModalmlo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_146 = { class: "modal-dialog" }
const _hoisted_147 = { class: "modal-content" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_149 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_150 = { class: "tw-flex tw-gap-[30px] tw-pl-[25px] tw-mb-4" }
const _hoisted_151 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_152 = { class: "w-50" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Average Fix Interest Rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "15 YEARS")
], -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_155 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%")
  ])
], -1)
const _hoisted_157 = { class: "data" }
const _hoisted_158 = ["onUpdate:modelValue"]
const _hoisted_159 = ["onUpdate:modelValue"]
const _hoisted_160 = ["onUpdate:modelValue"]
const _hoisted_161 = ["onUpdate:modelValue"]
const _hoisted_162 = ["onUpdate:modelValue"]
const _hoisted_163 = ["onUpdate:modelValue"]
const _hoisted_164 = { class: "w-50" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Average Fix Interest Rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "30 YEARS")
], -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_167 = { class: "pb-3" }
const _hoisted_168 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%")
  ])
], -1)
const _hoisted_170 = { class: "data" }
const _hoisted_171 = ["onUpdate:modelValue"]
const _hoisted_172 = ["onUpdate:modelValue"]
const _hoisted_173 = ["onUpdate:modelValue"]
const _hoisted_174 = ["onUpdate:modelValue"]
const _hoisted_175 = ["onUpdate:modelValue"]
const _hoisted_176 = ["onUpdate:modelValue"]
const _hoisted_177 = { class: "d-flex justify-content-between gap-4 mt-4" }
const _hoisted_178 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_179 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT LOWER THAN"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT HIGHER THAN"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %")
  ])
], -1)
const _hoisted_181 = { class: "text-left" }
const _hoisted_182 = ["onUpdate:modelValue"]
const _hoisted_183 = ["onUpdate:modelValue"]
const _hoisted_184 = ["onUpdate:modelValue"]
const _hoisted_185 = ["onUpdate:modelValue"]
const _hoisted_186 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_188 = ["onUpdate:modelValue"]
const _hoisted_189 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_190 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "tw-border-b-0"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "AVERAGE")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MIP %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PMI %")
  ])
], -1)
const _hoisted_192 = { class: "text-left" }
const _hoisted_193 = ["onUpdate:modelValue"]
const _hoisted_194 = ["onUpdate:modelValue"]
const _hoisted_195 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_197 = ["onUpdate:modelValue"]
const _hoisted_198 = { class: "d-flex justify-content-center mt-4 pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_199 = { class: "tw-flex tw-justify-between pt-4 gap-5" }
const _hoisted_200 = { class: "tw-w-1/2" }
const _hoisted_201 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_202 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "BACK END RATIO D&1 %")
  ])
], -1)
const _hoisted_203 = { class: "data" }
const _hoisted_204 = { class: "text-left" }
const _hoisted_205 = { class: "d-flex justify-content-between" }
const _hoisted_206 = ["onUpdate:modelValue"]
const _hoisted_207 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_208 = { class: "tw-w-1/2" }
const _hoisted_209 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PROGRAM"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MAXIMUM LOAN AMOUNT $")
  ])
], -1)
const _hoisted_211 = { class: "data" }
const _hoisted_212 = { class: "text-left" }
const _hoisted_213 = { class: "d-flex justify-content-between" }
const _hoisted_214 = ["onUpdate:modelValue"]
const _hoisted_215 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_217 = ["onUpdate:modelValue"]
const _hoisted_218 = {
  class: "modal fade modal-xl",
  id: "exampleModal8",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_219 = { class: "modal-dialog" }
const _hoisted_220 = { class: "modal-content" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_222 = { class: "modal-body" }
const _hoisted_223 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_224 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_226 = { key: 0 }
const _hoisted_227 = ["onClick"]
const _hoisted_228 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_229 = [
  _hoisted_228
]
const _hoisted_230 = { key: 1 }
const _hoisted_231 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_232 = [
  _hoisted_231
]
const _hoisted_233 = {
  class: "modal fade modal-xl",
  id: "exampleModal9",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_234 = { class: "modal-dialog" }
const _hoisted_235 = { class: "modal-content" }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_237 = { class: "modal-body" }
const _hoisted_238 = { class: "tw-flex" }
const _hoisted_239 = { class: "tw-pr-5 tw-pl-5" }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  selected: ""
}, "Select", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Done", -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Pending", -1)
const _hoisted_243 = [
  _hoisted_240,
  _hoisted_241,
  _hoisted_242
]
const _hoisted_244 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_245 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_246 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_247 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_248 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_249 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "INFO-MSG"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH MESSAGE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DONE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PENDING")
  ])
], -1)
const _hoisted_250 = ["onClick"]
const _hoisted_251 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_252 = [
  _hoisted_251
]
const _hoisted_253 = ["onUpdate:modelValue", "onChange"]
const _hoisted_254 = ["onUpdate:modelValue", "onChange"]
const _hoisted_255 = { key: 0 }
const _hoisted_256 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_257 = [
  _hoisted_256
]
const _hoisted_258 = {
  class: "modal fade",
  id: "exampleModal10",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_259 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_260 = { class: "modal-content" }
const _hoisted_261 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_262 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-text-xl" }, "MESSAGE")
], -1)
const _hoisted_263 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_264 = { class: "tw-flex" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-px-1" }, "DATE: ", -1)
const _hoisted_266 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_267 = { class: "tw-text-left" }
const _hoisted_268 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "REALTOR")
], -1)
const _hoisted_269 = /*#__PURE__*/_createElementVNode("span", null, "NAME: ", -1)
const _hoisted_270 = /*#__PURE__*/_createElementVNode("span", null, "PHONE NUMBER: ", -1)
const _hoisted_271 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL: ", -1)
const _hoisted_272 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_273 = {
  key: 0,
  class: "tw-text-left"
}
const _hoisted_274 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "CUSTOMER")
], -1)
const _hoisted_275 = /*#__PURE__*/_createElementVNode("span", null, "NAME: ", -1)
const _hoisted_276 = /*#__PURE__*/_createElementVNode("span", null, "PHONE NUMBER: ", -1)
const _hoisted_277 = {
  key: 1,
  class: "tw-text-left"
}
const _hoisted_278 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "INSPECTION")
], -1)
const _hoisted_279 = /*#__PURE__*/_createElementVNode("span", null, "INSPECTION ADDRESS: ", -1)
const _hoisted_280 = /*#__PURE__*/_createElementVNode("span", null, "DATE: ", -1)
const _hoisted_281 = /*#__PURE__*/_createElementVNode("span", null, "HOUR: ", -1)
const _hoisted_282 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_283 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "COMENTARY")
], -1)
const _hoisted_284 = { class: "tw-text-justify" }
const _hoisted_285 = { class: "tw-break-all tw-w-full" }
const _hoisted_286 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_287 = {
  key: 2,
  class: "tw-text-left"
}
const _hoisted_288 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip" }),
  /*#__PURE__*/_createTextVNode("ATTACHMENT")
], -1)
const _hoisted_289 = ["href"]
const _hoisted_290 = { key: 1 }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("span", { class: "tw-block mt-2" }, "No hay archivos", -1)
const _hoisted_292 = [
  _hoisted_291
]
const _hoisted_293 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_CompanyTitleForm = _resolveComponent("CompanyTitleForm")!
  const _component_RealtorFormat = _resolveComponent("RealtorFormat")!
  const _component_RealtorMLO = _resolveComponent("RealtorMLO")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      active: _ctx.loaderConfig.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
      "can-cancel": false,
      loader: 'dots',
      "is-full-page": !_ctx.loaderConfig.fullPage
    }, null, 8, ["active", "is-full-page"]),
    (_ctx.header === null)
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Overview video of the Realtor account",
          helpVideo: "https://www.realtortools.org/media/RealtorOverview.MP4",
          support: true
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              id: "segundoModal",
              "data-bs-toggle": "modal",
              "data-bs-target": "#exampleModal",
              href: "#",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadTable(null, null, true))),
              class: "tw-flex tw-items-center tw-bg-[#00A0DA] tw-w-[205px] tw-rounded-[15px] tw-pr-3 tw-pl-3 tw-pb-5 tw-pt-5"
            }, [
              _createElementVNode("img", {
                class: "tw-w-[40px]",
                src: require('@/assets/Images/iconos-05.png'),
                alt: ""
              }, null, 8, _hoisted_7),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("img", {
                class: "tw-w-[40px] tw-mr-3",
                src: require('@/assets/Images/iconos-02.png'),
                alt: ""
              }, null, 8, _hoisted_12),
              _createTextVNode(" CREATE (MLO & TITLE COMPANY) ")
            ]),
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", null, [
                _createElementVNode("button", _hoisted_14, [
                  _createElementVNode("img", {
                    class: "tw-w-[40px]",
                    src: require('@/assets/Images/iconos-01.png'),
                    alt: ""
                  }, null, 8, _hoisted_15),
                  _hoisted_16
                ])
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createElementVNode("button", _hoisted_18, [
                  _createElementVNode("img", {
                    class: "tw-w-[40px]",
                    src: require('@/assets/Images/iconos-04.png'),
                    alt: ""
                  }, null, 8, _hoisted_19),
                  _hoisted_20
                ])
              ])
            ])
          ]),
          _hoisted_21
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("table", _hoisted_28, [
                  _hoisted_29,
                  (_ctx.listInspectors.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(user.company_Name

                            ? user.company_Name

                            : user.username + " " + user.lastname), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            _createElementVNode("td", null, _toDisplayString(user.phonenumber), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listInspectors.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_31, _hoisted_33))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", null, [
                _createVNode(_component_CompanyTitleForm, {
                  userID: _ctx.userSession.iduser
                }, null, 8, ["userID"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  id: "openNoteModal1",
                  class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
                  style: {"border":"none"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                }, " SEE NOTE "),
                (_ctx.isCommentVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_52))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_RealtorFormat, {
                userId: _ctx.userSession.iduser
              }, null, 8, ["userId"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("table", _hoisted_59, [
                  _hoisted_60,
                  (_ctx.listUserSections.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_61, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(user.company_Name), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#exampleModaltitle",
                                href: "#",
                                onClick: ($event: any) => (_ctx.loadTable(user))
                              }, _hoisted_64, 8, _hoisted_62)
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listUserSections.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_65, _hoisted_67))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            (_ctx.tables && _ctx.tables.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _hoisted_78,
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("table", _hoisted_80, [
                              (_ctx.tables[0]?.data)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_81, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[0]?.data, (t) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(t.table_name), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((t.table_closing_close) = $event)
                                          }, null, 8, _hoisted_82), [
                                            [_vModelText, t.table_closing_close]
                                          ])
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(t.table_name2), 1),
                                        _createElementVNode("td", null, _toDisplayString(t.table_name3), 1)
                                      ]))
                                    }), 256))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _hoisted_87,
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("table", _hoisted_89, [
                              (_ctx.tables[1]?.data)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_90, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[1]?.data, (t) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(t.table_name), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((t.table_each_tittle_review) = $event)
                                          }, null, 8, _hoisted_91), [
                                            [_vModelText, t.table_each_tittle_review]
                                          ])
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(t.table_name2), 1)
                                      ]))
                                    }), 256))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _hoisted_95,
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("table", _hoisted_98, [
                  _hoisted_99,
                  (_ctx.listUserSections.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_100, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(user.username + " " + user.lastname), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#exampleModalinspector",
                                href: "#",
                                onClick: ($event: any) => (_ctx.loadTable(user))
                              }, _hoisted_103, 8, _hoisted_101)
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listUserSections.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_104, _hoisted_106))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_107
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_108, [
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _hoisted_111,
            (_ctx.tables && _ctx.tables.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _hoisted_117,
                          _hoisted_118,
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("table", _hoisted_121, [
                                _hoisted_122,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[0]?.data, (t) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": ($event: any) => ((t.table_name) = $event)
                                        }, null, 8, _hoisted_123), [
                                          [_vModelText, t.table_name]
                                        ])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          "onUpdate:modelValue": ($event: any) => ((t.table_until) = $event)
                                        }, null, 8, _hoisted_124), [
                                          [_vModelText, t.table_until]
                                        ])
                                      ])
                                    ]))
                                  }), 256))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_125, [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _hoisted_128,
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("table", _hoisted_131, [
                  _hoisted_132,
                  (_ctx.listUserSections.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_133, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(user.username + " " + user.lastname), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#exampleModalmlo",
                                href: "#",
                                onClick: ($event: any) => (_ctx.loadTable(user))
                              }, _hoisted_136, 8, _hoisted_134)
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listUserSections.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_137, _hoisted_139))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_140, [
        _createElementVNode("div", _hoisted_141, [
          _createElementVNode("div", _hoisted_142, [
            _hoisted_143,
            _createElementVNode("div", _hoisted_144, [
              _createVNode(_component_RealtorMLO)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_145, [
        _createElementVNode("div", _hoisted_146, [
          _createElementVNode("div", _hoisted_147, [
            _hoisted_148,
            (_ctx.tables.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "tw-bg-[#00a0da] tw-text-white tw-font-bold tw-w-[250px] tw-rounded-full tw-text-[16px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadTable(null, 'mlo_primary'))),
                        href: "#"
                      }, "Primary Property")
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "tw-bg-[#00a0da] tw-text-white tw-font-bold tw-w-[250px] tw-rounded-full ttw-text-[16px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadTable(null, 'mlo_second'))),
                        href: "#"
                      }, "Second Property")
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "tw-bg-[#00a0da] tw-text-white tw-font-bold tw-w-[250px] tw-rounded-full tw-text-[16px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadTable(null, 'mlo_investment'))),
                        href: "#"
                      }, "Investment")
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "tw-bg-[#00a0da] tw-text-white tw-font-bold tw-w-[250px] tw-rounded-full tw-text-[16px] tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadTable(null, 'mlo_special'))),
                        href: "#"
                      }, "Special Program")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, [
                      _hoisted_153,
                      _hoisted_154,
                      _createElementVNode("div", null, [
                        _createElementVNode("table", _hoisted_155, [
                          _hoisted_156,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[0]?.data, (t) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_157, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((t.fha_credit) = $event)
                                  }, null, 8, _hoisted_158), [
                                    [_vModelText, t.fha_credit]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((t.fha_percent) = $event)
                                  }, null, 8, _hoisted_159), [
                                    [_vModelText, t.fha_percent]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((t.coventional_credit) = $event)
                                  }, null, 8, _hoisted_160), [
                                    [_vModelText, t.coventional_credit]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((t.coventional_percent) = $event)
                                  }, null, 8, _hoisted_161), [
                                    [_vModelText, t.coventional_percent]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((t.va_credit) = $event)
                                  }, null, 8, _hoisted_162), [
                                    [_vModelText, t.va_credit]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((t.va_percent) = $event)
                                  }, null, 8, _hoisted_163), [
                                    [_vModelText, t.va_percent]
                                  ])
                                ])
                              ]))
                            }), 256))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_164, [
                      _hoisted_165,
                      _hoisted_166,
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("table", _hoisted_168, [
                          _hoisted_169,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[1]?.data, (t) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_170, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((t.fha_credit) = $event)
                                  }, null, 8, _hoisted_171), [
                                    [_vModelText, t.fha_credit]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((t.fha_percent) = $event)
                                  }, null, 8, _hoisted_172), [
                                    [_vModelText, t.fha_percent]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((t.coventional_credit) = $event)
                                  }, null, 8, _hoisted_173), [
                                    [_vModelText, t.coventional_credit]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((t.coventional_percent) = $event)
                                  }, null, 8, _hoisted_174), [
                                    [_vModelText, t.coventional_percent]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((t.va_credit) = $event)
                                  }, null, 8, _hoisted_175), [
                                    [_vModelText, t.va_credit]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((t.va_percent) = $event)
                                  }, null, 8, _hoisted_176), [
                                    [_vModelText, t.va_percent]
                                  ])
                                ])
                              ]))
                            }), 256))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("table", _hoisted_179, [
                        _hoisted_180,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[2]?.data, (t) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("td", _hoisted_181, _toDisplayString(t.table_name), 1),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_store_credit_lower_than) = $event)
                                }, null, 8, _hoisted_182), [
                                  [_vModelText, t.table_store_credit_lower_than]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_minimmum_down_payment) = $event)
                                }, null, 8, _hoisted_183), [
                                  [_vModelText, t.table_minimmum_down_payment]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_score_credit_higher_than) = $event)
                                }, null, 8, _hoisted_184), [
                                  [_vModelText, t.table_score_credit_higher_than]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_score_credit_higher_than_b) = $event)
                                }, null, 8, _hoisted_185), [
                                  [_vModelText, t.table_score_credit_higher_than_b]
                                ])
                              ])
                            ]))
                          }), 256))
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_186, [
                        _hoisted_187,
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[3]?.data, (t) => {
                              return (_openBlock(), _createElementBlock("td", null, [
                                _withDirectives(_createElementVNode("textarea", {
                                  name: "",
                                  id: "",
                                  cols: "30",
                                  rows: "5",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                }, null, 8, _hoisted_188), [
                                  [_vModelText, t.table_comments]
                                ])
                              ]))
                            }), 256))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_189, [
                      _createElementVNode("table", _hoisted_190, [
                        _hoisted_191,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[4]?.data, (t) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("td", _hoisted_192, _toDisplayString(t.table_name), 1),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_mip) = $event)
                                }, null, 8, _hoisted_193), [
                                  [_vModelText, t.table_mip]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_pmi) = $event)
                                }, null, 8, _hoisted_194), [
                                  [_vModelText, t.table_pmi]
                                ])
                              ])
                            ]))
                          }), 256))
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_195, [
                        _hoisted_196,
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[5]?.data, (t) => {
                              return (_openBlock(), _createElementBlock("td", null, [
                                _withDirectives(_createElementVNode("textarea", {
                                  name: "",
                                  id: "",
                                  cols: "30",
                                  rows: "5",
                                  "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                }, null, 8, _hoisted_197), [
                                  [_vModelText, t.table_comments]
                                ])
                              ]))
                            }), 256))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_198, [
                    _createElementVNode("div", _hoisted_199, [
                      _createElementVNode("div", _hoisted_200, [
                        _createElementVNode("table", _hoisted_201, [
                          _hoisted_202,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[6]?.data, (t) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_203, [
                                _createElementVNode("td", _hoisted_204, _toDisplayString(t.table_name), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_205, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((t.table_backend_ratio) = $event)
                                    }, null, 8, _hoisted_206), [
                                      [_vModelText, t.table_backend_ratio]
                                    ]),
                                    _hoisted_207
                                  ])
                                ])
                              ]))
                            }), 256))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_208, [
                        _createElementVNode("table", _hoisted_209, [
                          _hoisted_210,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[8]?.data, (t) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_211, [
                                _createElementVNode("td", _hoisted_212, _toDisplayString(t.table_name), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_213, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((t.table_input_mla) = $event)
                                    }, null, 8, _hoisted_214), [
                                      [_vModelText, t.table_input_mla]
                                    ])
                                  ])
                                ])
                              ]))
                            }), 256))
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_215, [
                          _hoisted_216,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[9]?.data, (t) => {
                                return (_openBlock(), _createElementBlock("td", null, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    name: "",
                                    id: "",
                                    cols: "30",
                                    rows: "5",
                                    "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                  }, null, 8, _hoisted_217), [
                                    [_vModelText, t.table_comments]
                                  ])
                                ]))
                              }), 256))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_218, [
        _createElementVNode("div", _hoisted_219, [
          _createElementVNode("div", _hoisted_220, [
            _hoisted_221,
            _createElementVNode("div", _hoisted_222, [
              _createElementVNode("div", _hoisted_223, [
                _createElementVNode("table", _hoisted_224, [
                  _hoisted_225,
                  (_ctx.listUserSections.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_226, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(user.company_Name

                            ? user.company_Name

                            : user.username + " " + user.lastname), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#exampleModal9",
                                href: "#",
                                onClick: ($event: any) => (_ctx.loadMessages(user))
                              }, _hoisted_229, 8, _hoisted_227)
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listUserSections.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_230, _hoisted_232))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_233, [
        _createElementVNode("div", _hoisted_234, [
          _createElementVNode("div", _hoisted_235, [
            _hoisted_236,
            _createElementVNode("div", _hoisted_237, [
              _createElementVNode("div", _hoisted_238, [
                _createElementVNode("div", null, [
                  _createVNode(_component_datepicker, {
                    "auto-apply": "",
                    class: "w-100",
                    range: "",
                    "text-input": _ctx.configDatePicker,
                    modelValue: _ctx.configDatePicker.date,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                      _ctx.changeDate
                    ],
                    placeholder: "Enter date range..."
                  }, null, 8, ["text-input", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_239, [
                  _withDirectives(_createElementVNode("select", {
                    class: "btn-select tw-bg-[#00a0da] tw-text-white tw-pl-3 tw-pr-5 tw-pt-2 tw-pb-2 tw-rounded-full tw-cursor-pointer",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterMailState())),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterMails.state) = $event))
                  }, _hoisted_243, 544), [
                    [_vModelSelect, _ctx.filterMails.state]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_244, [
                _createElementVNode("div", _hoisted_245, [
                  _createElementVNode("div", _hoisted_246, [
                    _createElementVNode("div", _hoisted_247, [
                      _createElementVNode("table", _hoisted_248, [
                        _hoisted_249,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSortedMails, (mail, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(mail.subject), 1),
                              _createElementVNode("td", null, _toDisplayString(mail.date2), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#exampleModal10",
                                  onClick: ($event: any) => (_ctx.selectMail(mail)),
                                  href: "#"
                                }, _hoisted_252, 8, _hoisted_250)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((mail.maildone) = $event),
                                  onChange: ($event: any) => (_ctx.updateMail(mail)),
                                  class: "tw-w-[20px] tw-h-[20px]"
                                }, null, 40, _hoisted_253), [
                                  [_vModelCheckbox, mail.maildone]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((mail.mailpending) = $event),
                                  onChange: ($event: any) => (_ctx.updateMail(mail)),
                                  class: "tw-w-[20px] tw-h-[20px]"
                                }, null, 40, _hoisted_254), [
                                  [_vModelCheckbox, mail.mailpending]
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        (_ctx.listUserSections.length == 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_255, _hoisted_257))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_258, [
        _createElementVNode("div", _hoisted_259, [
          _createElementVNode("div", _hoisted_260, [
            (_ctx.selectedMail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_261, [
                  _hoisted_262,
                  _hoisted_263,
                  _createElementVNode("div", _hoisted_264, [
                    _hoisted_265,
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.date1), 1)
                  ]),
                  _hoisted_266,
                  _createElementVNode("div", _hoisted_267, [
                    _hoisted_268,
                    _createElementVNode("div", null, [
                      _hoisted_269,
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.fromdata[0].username +

                    " " +

                    _ctx.selectedMail.fromdata[0].lastname), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_270,
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.fromdata[0].phone_Number), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_271,
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.fromdata[0].email), 1)
                    ])
                  ]),
                  _hoisted_272,
                  (!_ctx.selectedMail.inspection_mail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_273, [
                        _hoisted_274,
                        _createElementVNode("div", null, [
                          _hoisted_275,
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.todata[0].username +

                    " " +

                    _ctx.selectedMail.todata[0].lastname), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_276,
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.todata[0].phone_Number), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedMail.inspection_mail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                        _hoisted_278,
                        _createElementVNode("div", null, [
                          _hoisted_279,
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.inspection_address), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_280,
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.inspectiondate), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_281,
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedMail.inspection_hour), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_282,
                  _hoisted_283,
                  _createElementVNode("div", _hoisted_284, [
                    _createElementVNode("span", _hoisted_285, _toDisplayString(_ctx.selectedMail.message), 1)
                  ]),
                  _hoisted_286,
                  (!_ctx.selectedMail.inspection_mail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                        _hoisted_288,
                        (_ctx.selectedMail.attached_file)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "tw-block mt-2",
                              href: _ctx.URL + _ctx.selectedMail.attached_file,
                              download: "",
                              target: "_blank"
                            }, _toDisplayString(_ctx.selectedMail.attached_file.replace("uploads/", "")), 9, _hoisted_289))
                          : (_openBlock(), _createElementBlock("div", _hoisted_290, _hoisted_292))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_293, [
              _createElementVNode("button", {
                type: "button",
                class: "accept btn btn-secondary",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeMailModal()))
              }, " Return ")
            ])
          ])
        ])
      ])
    ])
  ]))
}